import { EleCodeEnum, emailReg } from '@inv/constants'
import { FieldStatusEnum } from '@inv/hooks'
import { IsFieldSubmittable } from './BlockModel/typing'
import { UserFeedbackCodeEnum } from './constants'

export function getFieldDefaultValue(code: string | number) {
  switch (code) {
    // EleCode 架构
    case EleCodeEnum.Email:
      return 0
    default:
      return ''
  }
}

export const isFieldSubmittable: IsFieldSubmittable = (field, core) => {
  const code = field?.name?.[0]
  const status = field?.meta?.status

  switch (status) {
    case FieldStatusEnum.Success:
      return true
    case FieldStatusEnum.UnCheck:
      switch (code) {
        case UserFeedbackCodeEnum.Scenario:
          if (core.isIgnoreInForm(UserFeedbackCodeEnum.Scenario)) {
            return true
          }
          return false
        case UserFeedbackCodeEnum.Description:
          return false
        case UserFeedbackCodeEnum.EmailCheckBox:
          return true
        case UserFeedbackCodeEnum.Attachment:
          return true
        case EleCodeEnum.Email:
          if (core.isIgnoreInForm(EleCodeEnum.Email)) {
            return true
          }
          if (field?.meta?.initial?.value && emailReg.test(field?.value)) {
            return true
          }
          return false
        default:
          return false
      }
    case FieldStatusEnum.Invalid:
      switch (code) {
        case UserFeedbackCodeEnum.Scenario:
          if (core.isIgnoreInForm(UserFeedbackCodeEnum.Scenario)) {
            return true
          }
          return false
        case EleCodeEnum.Email:
          if (core.isIgnoreInForm(EleCodeEnum.Email)) {
            return true
          }
          return false
        default:
          return false
      }
    default:
      return false
  }
}
